import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import Routes from './routers'

import auth from './auth' // 绑定
import Login from '@/view/login' // 登录
import Forget from '@/view/forget' // 登录
import shopLogin from '@/view/shoplogin' // 店铺登录
import shopList from '@/view/shoplist' // 店铺登录
import Record from '@/view/vshopuserrecord' // 未绑定微信的空页面
import Unbind from '@/view/base/empty/unbind' // 未绑定微信的空页面

import fetch from '../utils/fetch'
import loadRouters from './loadRouters'
import activeLicense from '@/view/base/asset/accountactivation/index'
Vue.use(VueRouter)

const pathPrefix = process.env.PREFIXES

let passport = {
  path: pathPrefix ? `/${pathPrefix}/login` : '/sysmanagerlogin',
  component: Login,
  name: '',
  hidden: true
}

let forget = {
  path: pathPrefix ? `/${pathPrefix}/forget` : '/forget',
  component: Forget,
  name: '',
  hidden: true
}

let shoppassport = {
  path: pathPrefix ? `/${pathPrefix}/shopadmin/login` : '/shopadmin/login',
  component: shopLogin,
  name: '',
  hidden: true
}

let shoplistpassport = {
  path: pathPrefix ? `/${pathPrefix}/shopadmin/shoplist` : '/shopadmin/shoplist',
  component: shopList,
  name: '店铺选择列表页',
  hidden: true
}


let unbind = {
  path: pathPrefix ? `/${pathPrefix}/unbind` : '/unbind',
  component: Unbind,
  name: '绑定页',
  hidden: true
}

let activelicense = {
  path: pathPrefix ? `/${pathPrefix}/activelicense` : '/activelicense',
  component: activeLicense,
  name: '未登录用户激活页',
  hidden: true
}

let record = {
  path: '/record',
  component: Record,
  name: '用户体测报告',
  hidden: true
}

const router = new VueRouter({
  routes: [passport, shoppassport, shoplistpassport, unbind, forget, auth, activelicense, record, ...loadRouters.addRouters() || ''],
  mode: 'history'
})

const routerBefore = {
  goToPath: function (to, from, next) {
    let licenseValid = JSON.parse(Base64.decode(store.getters.license_authorize));
    if (licenseValid && (licenseValid.valid == 'false' || !licenseValid.valid)) {
      if (to.path.indexOf('assetaccountactivation') === -1) {
        next({ path: matchInternalRoute('assetaccountactivation') })
        NProgress.done()
      } else {
        next()
      }
    } else if (to.path === passport.path) {
      next({ path: pathPrefix ? `/${pathPrefix}` : '/' })
      NProgress.done()
    } else if (to.path === shoppassport.path) {
      next({ path: pathPrefix ? `/${pathPrefix}/shopadmin` : '/shopadmin'})
      NProgress.done()
    } else {
      next()
    }
  }
}

const matchInternalRoute = function (name) {
  const menus = store.getters.menus
  if (menus) {
    return findName(menus, name)
  }
  function findName (menus, name) {
    for (let item of menus) {
      let url = item.url.split('/')
      if (url[url.length - 1] === name) {
        return item.url
      }
      if (item.children && item.children.length > 0) {
        let obj = findName(item.children, name)
        if (obj) {
          return obj
        }
      }
    }
  }
}

const whiteList = [passport.path, forget.path, shoppassport.path, activelicense.path, '/record']// 不重定向白名单
router.beforeEach((to, from, next) => {
  if (to.path.indexOf('shopadmin') !== -1) {
    store.dispatch('setLoginType', 'distributor')
  } else {
    store.dispatch('setLoginType', 'default')
  }
  // 保证类型已经存储到cookie中了
  setTimeout(function(){ console.log(store.getters.login_type) }, 200);

  NProgress.start()

  let timestamp = (Date.parse(new Date())) / 1000
  if (store.getters.token && whiteList.indexOf(to.path) === -1) {
    // 验证token有效期 提前五分种刷新token
    if (Number(store.getters.exp) - timestamp <= 3000) {
      fetch({ url: '/token/refresh', method: 'get'}).then(response => {
        store.dispatch('setToken', response.headers.authorization)
        routerBefore.goToPath(to, from, next)
      })
      .catch(error => {
        if (to.path.indexOf('shopadmin') !== -1) {
          next(shoppassport.path) // 否则全部重定向到登录页
        } else {
          next(passport.path) // 否则全部重定向到登录页
        }
        NProgress.done() // 在hash模式下 改变手动改变hash 重定向回来 不会触发afterEach 暂时hack方案 ps：history模式下无问题，可删除该行！
      })
    } else if (!store.getters.menus) {
      fetch({ url: '/permission', method: 'get'}).then(response => {
        store.dispatch('setMenu', response.data.data)
        let extendsRoutes = loadRouters.addRouters(res.data.data)
        this.$router.addRoutes(extendsRoutes)
        routerBefore.goToPath(to, from, next)
      })
    } else {
      routerBefore.goToPath(to, from, next)
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) { // 在免登录白名单，直接进入
      next()
    } else {
      // let url = 'https://yaoking.cn'
      if  (to.path.indexOf('shopadmin') !== -1) {
        // next(shoppassport.path) // 否则全部重定向到登录页
        // window.location.href = url
        // 向页面中写入一段文字
        // document.write('<h1 style="text-align:center;">404 Not Found</h1>')
        // 覆盖掉 head 中的内容
        document.head.innerHTML = '<title>404 Not Found</title>'
        // 覆盖掉 body 中的内容
        document.body.innerHTML = '<h1 style="text-align:center;">404 Not Found</h1><hr>'
      } else {
        // next(passport.path) // 否则全部重定向到登录页
        // window.location.href = url
        // 向页面中写入一段文字
        // document.write('<h1 style="text-align:center;">404 Not Found</h1>')
        // 覆盖掉 head 中的内容
        document.head.innerHTML = '<title>404 Not Found</title>'
        // 覆盖掉 body 中的内容
        document.body.innerHTML = '<h1 style="text-align:center;">404 Not Found</h1><hr>'
      }
      NProgress.done() // 在hash模式下 改变手动改变hash 重定向回来 不会触发afterEach 暂时hack方案 ps：history模式下无问题，可删除该行！
    }
  }
})

router.afterEach(transition => {
  if (!transition.name && whiteList.indexOf(transition.path) === -1 && store.getters.menus) {
    window.location = store.getters.menus[0].url
  }
  NProgress.done()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js